export default __webpack_public_path__ + "static/wwf-3d48f9a7deb348d926e8b5a00b6e6b25.svg";